import { useQuery } from '@tanstack/react-query';
import { fetchPartners, Partner } from '../services/partnerService';

export const partnerKeys = {
  all: ['partners'] as const,
};

export const usePartners = () => {
  return useQuery<Partner[]>({
    queryKey: partnerKeys.all,
    queryFn: fetchPartners,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
